import { SmartRenderer } from '@fusioncharts/core/src/component-interface';
import { sankeyRibbon } from './sankey-ribbon';
import { parseColor, isIpad, parseTooltext } from '@fusioncharts/core/src/lib';

const CUSTOM = 'custom',
  UNIFORM = 'uniform',
  BLANKSTRING = '',
  SMALLSQUARE = '&#9632;',
  MEDIUMSQUARE = '&#x25FC;',
  getTooltext = (config, link, chartConfig) => {
    let uniChar = isIpad ? SMALLSQUARE : MEDIUMSQUARE,
      macroIndices = [148, 149, 142, 150, 151, 152, 153],
      manager = link.getLinkedParent(),
      legend = link.getFromEnv('legend'),
      pathArr,
      drawCustomLegendIcon = chartConfig && chartConfig.drawcustomlegendicon,
      newPathArr = [],
      i,
      j,
      symbolBBox,
      legendItemSymbol,
      pathStart = [],
      finalPath,
      fromLegendItem = (drawCustomLegendIcon && legend && legend.config && legend.config.isActive) ? legend.getItem(manager.config.legendItemMap[link.config.from]) : null,
      fromgraphicalElement = fromLegendItem && fromLegendItem.getGraphicalElement(),
      toLegendItem = (drawCustomLegendIcon && legend && legend.config && legend.config.isActive) ? legend.getItem(manager.config.legendItemMap[link.config.to]) : null,
      tographicalElement = toLegendItem && toLegendItem.getGraphicalElement(),
      parserConfig,
      linkToolText;
    finalPath = BLANKSTRING;
    if (fromLegendItem) {
      if (fromgraphicalElement) {
        legendItemSymbol = fromgraphicalElement && fromgraphicalElement.legendItemSymbol;
        pathArr = legendItemSymbol && legendItemSymbol.attrs.path.split(/(?=[LMCA])/);
        symbolBBox = legendItemSymbol && legendItemSymbol.node.getBBox();
        if (pathArr && pathArr.length) {
          for (i = 0; i < pathArr.length; i++) {
            pathStart.push(pathArr[i][0]);
            pathArr[i] = pathArr[i].substring(1, pathArr[i].length);
            if (i === (pathArr.length - 1)) {
              pathArr[i] = pathArr[i].substring(0, pathArr[i].length - 1);
            }
            newPathArr[i] = pathArr[i].split(',');
          }
        }
        if (newPathArr && newPathArr.length) {
          for (i = 0; i < newPathArr.length; i++) {
            if (newPathArr[i].length) {
              for (j = 0; j < newPathArr[i].length; j++) {
                newPathArr[i][j] = Number(newPathArr[i][j]);
                if (pathStart[i] !== 'A') {
                  if (j === 0) {
                    newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.x);
                  } else if (j === 1) {
                    newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.y);
                  }
                } else if (pathStart[i] === 'A') {
                  if (j === 5) {
                    newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.x);
                  } else if (j === 6) {
                    newPathArr[i][j] = newPathArr[i][j] - (symbolBBox.y);
                  }
                }
              }
            }
            finalPath += pathStart[i] + newPathArr[i].toString();
          }
        }
        finalPath = finalPath + 'Z';
      }
    }
    parserConfig = {
      linkDataValue: config.value,
      fromPlotIdentifier: fromLegendItem ? `<svg height= ${symbolBBox.height} width = ${symbolBBox.width} overflow='visible' xmlns="http://www.w3.org/2000/svg">
      <path d= ${finalPath} fill = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('fill')} stroke = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('stroke')}
      stroke-opacity = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('stroke-opacity')} fill-opacity = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('fill-opacity')} 
      stroke-width = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('stroke-width')} stroke-linecap = ${fromgraphicalElement.legendItemSymbol.node.getAttribute('stroke-linecap')}></path>
    </svg>` : `<span style='color: ${parseColor(config.sourceFill)};'>${uniChar}&nbsp;</span>`,
      toPlotIdentifier: toLegendItem ? `<svg height= ${symbolBBox.height} width = ${symbolBBox.width} overflow= 'visible' xmlns="http://www.w3.org/2000/svg">
      <path d= ${finalPath} fill = ${tographicalElement.legendItemSymbol.node.getAttribute('fill')} stroke = ${tographicalElement.legendItemSymbol.node.getAttribute('stroke')}
      stroke-opacity = ${tographicalElement.legendItemSymbol.node.getAttribute('stroke-opacity')} fill-opacity = ${tographicalElement.legendItemSymbol.node.getAttribute('fill-opacity')} 
      stroke-width = ${tographicalElement.legendItemSymbol.node.getAttribute('stroke-width')} stroke-linecap = ${tographicalElement.legendItemSymbol.node.getAttribute('stroke-linecap')}></path>
    </svg>` : `<span style='color: ${parseColor(config.targetFill)};'>${uniChar}&nbsp;</span>`,
      flowDirection: `&rarr;`
    };
    linkToolText = parseTooltext(config.toolText, macroIndices,
      config, parserConfig);
    config.setLinkTooltext = linkToolText;
    if (!config.toolText) {
      return (
        `<div style='padding: 2px; vertical-align: middle;'>
        <span style='color: ${parseColor(config.sourceFill)};'>${uniChar}&nbsp;</span>${config.props.source.label}
        &rarr;
        <span style='color: ${parseColor(config.targetFill)}'>${uniChar}&nbsp;</span>${config.props.target.label}
        &nbsp;
        ${config.value}
      </div>`
      );
    }
    return (
      `<div style='padding: 2px; vertical-align: middle;'>
        ${config.setLinkTooltext}
      </div>`
    );
  };
class SankeyLink extends SmartRenderer {
  getType () {
    return 'link';
  }

  getName () {
    return 'sankey-link';
  }

  configureAttributes (inputConfig = {}) {
    Object.assign(this.config, inputConfig);
  }

  allocatePosition () {
    let link = this,
      linkConfig = link.config,
      { mode, style, props, linkPadding, linkType, curvature } = linkConfig,
      { orientation } = link.getFromEnv('chartConfig'),
      linkCosmetics = style.link[mode],
      pathStr,
      sourcePoint = {
        x: props.x0,
        y: props.y0,
        width: props.linkWidth
      },
      { source, target } = props,
      sourceNodeLayer = source.props.layer,
      targetNodeLayer = target.props.layer,
      sourceNodeLen,
      targetNodeLen,
      targetPoint = {
        x: props.x1,
        y: props.y1,
        width: props.linkWidth
      },
      { columnGap } = link.getLinkedParent().config;

    sourceNodeLen = Math.max(orientation === 'vertical' ? source.props.x1 - source.props.x0 : source.props.y1 - source.props.y0, 0);
    targetNodeLen = Math.max(orientation === 'vertical' ? source.props.x1 - source.props.x0 : source.props.y1 - source.props.y0, 0);

    if (linkType !== CUSTOM && linkType !== UNIFORM) {
      if (
        (props.linkWidth > (columnGap * Math.abs(targetNodeLayer - sourceNodeLayer) / 3)) ||
        (sourcePoint.width > 0.7 * sourceNodeLen) ||
        (targetPoint.width > 0.7 * targetNodeLen)
      ) {
        linkType = CUSTOM;
      } else {
        linkType = UNIFORM;
      }
    }
    pathStr = sankeyRibbon(sourcePoint, targetPoint, {
      orientation,
      padding: linkPadding,
      curvature,
      linkType
    });

    linkConfig.linkAttr = {
      path: pathStr,
      'stroke-width': linkType === UNIFORM ? props.linkWidth : 'none',
      ...linkCosmetics
    };

    if (linkType === CUSTOM) {
      linkConfig.linkAttr.fill = linkConfig.linkAttr.stroke;
      linkConfig.linkAttr.stroke = 'none';
    }
  }

  draw () {
    let link = this,
      linkConfig = link.config,
      chartConfig = link.getFromEnv('chartConfig'),
      { id, linkAttr } = linkConfig;

    link.addGraphicalElement({
      el: 'path',
      attr: linkAttr,
      container: {
        id: 'sankey-link-group',
        label: 'linkGroup',
        isParent: true
      },
      tooltext: getTooltext(link.config, link, chartConfig),
      component: link,
      id: id,
      label: 'sankey-link'
    });
  }
}

export default SankeyLink;
